import React, { useEffect, useState } from 'react'
import { me } from '../services/auth'
import { useTranslation } from '../hooks/useTranslation'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireVerification?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireVerification = true 
}) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState<any>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    me()
      .then(userData => {
        if (!userData) {
          setError(t('auth.loginRequired'))
          return
        }
        if (requireVerification && !userData.email_verified_at) {
          setError(t('auth.verificationRequired'))
          return
        }
        setUser(userData)
      })
      .catch(() => {
        setError(t('auth.loginRequired'))
      })
      .finally(() => {
        setLoading(false)
      })
  }, [requireVerification, t])

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f4efed] dark:bg-[#081630] flex items-center justify-center">
        <div className="text-center">
          <div className="text-gray-700 dark:text-gray-300">
            {t('common.loading')}
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#f4efed] dark:bg-[#081630] flex items-center justify-center">
        <div className="max-w-md mx-auto text-center">
          <div className="bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 p-6 rounded-lg mb-4">
            <h2 className="text-xl font-bold mb-2">
              {t('auth.accessDenied')}
            </h2>
            <p className="mb-4">{error}</p>
            <div className="space-y-2">
              <a 
                href="/login" 
                className="block w-full px-4 py-2 bg-[#059be6] text-white rounded hover:bg-[#059be6]"
              >
                {t('auth.loginLabel')}
              </a>
              <a 
                href="/verify-email" 
                className="block w-full px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
              >
                {t('auth.verifyEmailLabel')}
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
